import React from 'react';
import {
  HomeIcon,
  UserGroupIcon,
  BuildingStorefrontIcon,
  DocumentChartBarIcon,
  QueueListIcon,
  TruckIcon,
  Cog8ToothIcon,
  EnvelopeOpenIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';

export const defaultNavItems = [
  {
    label: 'Dashboard',
    href: '/',
    icon: <HomeIcon className="w-6 h-6 text-green-400" />,
  },
  {
    label: 'Email Received',
    href: '/emails',
    icon: <EnvelopeOpenIcon className="w-6 h-6 text-blue-400" />,
  },
  {
    label: 'Email Sent',
    href: '/email-sent',
    icon: <EnvelopeOpenIcon className="w-6 h-6 text-indigo-400" />,
  },
  {
    label: 'RFQ Master',
    href: '/rfq',
    icon: <QueueListIcon className="w-6 h-6 text-purple-400" />,
  },
  {
    label: 'PO Master',
    href: '/po',
    icon: <DocumentChartBarIcon className="w-6 h-6 text-orange-400" />,
  },
  {
    label: 'Deliveries',
    href: '/deliveries',
    icon: <TruckIcon className="w-6 h-6 text-yellow-400" />,
  },
  {
    label: 'Vendors',
    href: '/vendors',
    icon: <BuildingStorefrontIcon className="w-6 h-6 text-pink-400" />,
  },
  {
    label: 'Contracting Officers',
    href: '/contracting-officer',
    icon: <UserGroupIcon className="w-6 h-6 text-teal-400" />,
  },
  {
    label: 'Users',
    href: '/users',
    icon: <UserGroupIcon className="w-6 h-6 text-cyan-400" />,
  },
  {
    label: 'Reports',
    href: '/reports',
    icon: <ChartBarIcon className="w-6 h-6 text-red-400" />,
  },
  {
    label: 'Email Templates',
    href: '/settings',
    icon: <Cog8ToothIcon className="w-6 h-6 text-gray-400" />,
  },
  {
    label: 'Invoice Templates',
    href: '/invoice-template',
    icon: <Cog8ToothIcon className="w-6 h-6 text-amber-400" />,
  },
];
